/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

export const FORMULA_FUNCTIONS = {
  'mod': { argCount: 2 },
  'abs': { argCount: 1 },
  'ceil': { argCount: 1 },
  'exp': { argCount: 1 },
  'floor': { argCount: 1 },
  'ln': { argCount: 1 },
  'log': { argCount: [1, 2] },
  'greatest': { argCount: 2 },
  'least': { argCount: 2 },
  'pi': { argCount: 1 },
  'round': { argCount: 1 },
  'sqrt': { argCount: 1 },
  'trunc': { argCount: 1 },
  'atan': { argCount: 1 },
  'cos': { argCount: 1 },
  'radians': { argCount: 1 },
  'sin': { argCount: 1 },
  'tan': { argCount: 1 },
};

export const FORMULA_OPERATORS = ['(', ')', '+', '-', '*', '/', '^'];

export const FORMULA_DEFAULT_SNIPPETS = {
  MathFunctions: [
    'mod(y, x)',
    'abs(x)',
    'ceil(x)',
    'exp(x)',
    'floor(x)',
    'ln(x)',
    'log(x)',
    'log(2, x)',
    'greatest(x, y)',
    'least(x, y)',
    'pi()',
    'round(x)',
    'sqrt(x)',
    'trunc(x)',
  ],
  Operators: FORMULA_OPERATORS,
  TrigFunctions: [
    'atan(x)',
    'cos(radians(x))',
    'cos(x)',
    'radians(x)',
    'sin(radians(x))',
    'sin(x)',
    'tan(radians(x))',
    'tan(x)',
  ],
};
